import axios from 'axios'

// Configuración base de axios
const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: true, // Habilitar el envío de cookies automáticamente
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
})

// Interceptor para manejar errores globalmente
api.interceptors.response.use(
    response => response,
    error => {
        console.error('API Error:', error)
        return Promise.reject(error)
    }
)

// Interceptor para agregar cookies automáticamente a las peticiones
api.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)

export default api 